module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"form__filter\">\n	<div class=\"table\">\n		<div>\n			<div class=\"title\">\n				Название\n			</div>\n			<div>\n				<control type=\"text\" target=\"filter.name\" />\n			</div>\n			<div>\n				<button on-click=\"onFilterClick\">Фильтровать</button>\n			</div>\n		</div>\n	</div>\n</div>")
  }
  return __output.join("");

}